import { FC } from "react";
import { AdminAccountResDto } from "service/api/estabrookSchemas";
import WarningConfirmDialog from "./WarningConfirmDialog";

export interface MemberAccessConfirmDialogProps {
  member: AdminAccountResDto | null;
  isSubmitting: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const MemberAccessConfirmDialog: FC<MemberAccessConfirmDialogProps> = ({
  member,
  isSubmitting,
  onConfirm,
  onCancel,
}) => {
  const isDeactivating = member ? member.isActive : false;
  const actionLabel = isDeactivating ? "Remove Access" : "Restore Access";

  return (
    <WarningConfirmDialog
      open={Boolean(member)}
      title={actionLabel}
      description={`Are you sure you want to ${
        isDeactivating ? "remove" : "restore"
      } access for ${member?.firstName} ${member?.lastName}?`}
      warningText={
        isDeactivating
          ? "They will be logged out immediately and will no longer be able to sign in."
          : undefined
      }
      confirmLabel={actionLabel}
      isSubmitting={isSubmitting}
      onConfirm={onConfirm}
      onCancel={onCancel}
      confirmTestId="confirm-member-access-toggle"
      cancelTestId="cancel-member-access-toggle"
    />
  );
};

export default MemberAccessConfirmDialog;
